import { LidoWstEthAbi } from '../abis/lido'
import { TotalSupplyAbi } from '../abis/shared'
import type { LstRegistryEntry } from '../registry'
import { ONE_E18, toBigInt, type LstReader } from './shared'

/**
 * Lido wstETH reader.
 *
 * Two calls: `wstETH.totalSupply()` + `wstETH.stEthPerToken()`.
 * `totalAssets` is the stETH held by the wrapper, computed as
 * `totalSupply * stEthPerToken / 1e18` — wstETH has no direct
 * `totalAssets()` getter, this is the closest invariant.
 */
export const readerLidoWstEth = (entry: LstRegistryEntry): LstReader => ({
  calls: [
    { address: entry.address, name: 'totalSupply', params: [] },
    { address: entry.address, name: 'stEthPerToken', params: [] },
  ],
  abis: [TotalSupplyAbi, LidoWstEthAbi],
  parse: ([supply, rate]) => {
    const totalSupply = toBigInt(supply)
    const exchangeRate = toBigInt(rate)
    if (totalSupply === undefined || exchangeRate === undefined) {
      return undefined
    }
    return {
      totalAssets: (totalSupply * exchangeRate) / ONE_E18,
      totalSupply,
      exchangeRate,
    }
  },
})
